<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2">

            ثبت و ویرایش کاربران سفر
        
        </span>

    </div>

</div>

<main style="direction: rtl;" class="px-2">

    <div class="border border-2 container-fluid row gx-2 gy-2 mt-3 p-2">

        <div class="col-12 col-md-9">

            <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (input)="filter($event.target)">

        </div>

        <div class="col-12 col-md-auto d-flex align-items-center">

            <button class="btn btn-primary w-100" (click)="newUser()"> ثبت کاربر </button>

        </div>

        <div class="col-12 col-md-auto d-flex align-items-center">

            <button class="btn btn-success w-100" (click)="exportexcel('Export_Excel')"> خروجی اکسل </button>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 150px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>
            
                    <tr class="text-center">
        
                        <th scope="col" class="">عملیات</th>

                        <th scope="col" class="pointer">نام و نام خانوادگی </th>
    
                        <th scope="col" class="">نام کاربری</th>
    
                        <th scope="col" class=""> حوزه خدمتی  </th>

                        <th scope="col" class=""> جایگاه سازمانی </th>
    
                        <th scope="col" class="pointer">تاریخ پایان اعتبار </th>
    
                        <th scope="col" class="pointer">تعداد ورود </th>
    
                        <th scope="col" class="">حداکثر تعداد ورود</th>
    
                        <th scope="col" class="pointer">تاریخ آخرین ورود </th>
    
                        <th scope="col" class="">تعداد خودرو مجاز</th>
        
                    </tr>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of list_Users;let i = index">

                        <th class="text-secondary">

                            <i title="ویرایش" class="fa fa-edit text-primary fa-lg pointer" (click)="editUserModal(item,i)"> </i>
    
                            <i title="حذف" class="fa fa-trash text-danger mx-2 fa-lg pointer" (click)="deleteUser(item.iSystemUser)"></i>
    
                            <i title="دسترسی" class="fa fa-hand-paper-o text-success fa-lg pointer" (click)="access(item.iSystemUser)"></i>
    
                            <i title="اختصاص خودرو" class="fa fa-car text-dark mx-2 fa-lg pointer" (click)="assignCar(item.iSystemUser)"></i>
    
                            <i *ngIf="bAcssess.bUserManagment"  title="حوزه خدمتی کاربر" class="fa fa-university text-primary fa-lg pointer" (click)="getUserSchool(item)"></i>

                            <i *ngIf="bAcssess.bUserManagment_Group" title="گروه کاربری " class="fa fa-user-circle mx-2 fa-lg pointer" (click)="getUserGroup(item)"></i>
    
                            <i *ngIf="bAcssess.bUserManagment" title=" حوزه های خدمتی تحت نظارت کاربر " class="fa fa-building text-dark fa-lg pointer" (click)="getUserSchool(item,'supervision_service')"></i>
    
                            <i title="سابقه فعالیت کاربر" class="fa fa-list text-success fa-lg pointer me-2" (click)="userHistory(item.iSystemUser)"></i>
    
                        </th>
    
                        <td class="text-dark">{{item.strFullName | faNum }}</td>
    
                        <td class="text-dark">{{item.strUserName | faNum}}</td>
    
                        <td class="text-dark">{{item.strMobile_strComment |faNum}}</td>

                        <td class="text-dark">{{item.strUserManager_Chart_strComment |faNum}}</td>
    
                        <td class="text-dark">{{item.strEsterakEndDate|faNum}}</td>
    
                        <td class="text-dark">{{item.iInput|faNum}}</td>
    
                        <td class="text-dark">{{item.iMaxInput|faNum}}</td>
    
                        <td class="text-dark">{{item.strLastLoginDateTime |faNum}}</td>
    
                        <td class="text-dark">{{item.iMaxMobile|faNum}}</td>

                    </tr>

                </tbody>
    
            </table>

        </div>

    </div>

</main>

<!-- افزودن و ویرایش -->

<div class="modal fade" id="add_Edit_User" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content" style="direction: rtl;">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel"> {{ bEditMode ? 'ویرایش کاربر' : 'افزودن کاربر' }} </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <!-- فرم بررسی نام کاربری -->

                <!-- اگر مد ویرایش نبود -->

                <ng-container *ngIf="!bEditMode">

                    <form [formGroup]="mdl_Search">

                        <div class="container-fluid row gx-2 gy-2 p-2">
    
                            <div class="position-relative col-12 col-md-10 p-2">
                    
                                <label class="mb-2 text-muted"> نام کاربری </label>
                    
                                <input class="form-control p-2" formControlName="strUserName" 
    
                                    [ngClass]="mdl_Search.get('strUserName')?.value != '' ? 'text-center' : '' "
                                
                                    placeholder="نام کاربری یا شماره موبایل را جهت بررسی وارد کنید">
                    
                            </div>
    
                            <div class="position-relative col-12 col-md-auto p-2">
    
                                <button class="btn btn-primary w-100" (click)="checkUserName()"> بررسی </button>
    
                            </div>
                    
                        </div>     
                        
                        <hr class="mx-3">
    
                    </form>

                </ng-container>

                <!-- فرم ذخیره, ویرایش کاربر -->

                <form [formGroup]="mdl_User">

                    <div class="container-fluid row gx-2 gy-2 p-2">

                        <!-- نام و نام خانوادگی -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> نام و نام&zwnj;خانوادگی </label>
                
                            <input class="form-control p-2 text-center" formControlName="strFullName">
                
                        </div>
                                                
                        <!-- حوزه خدمت -->

                        <div class="position-relative col-12 col-md-4 p-2">
        
                            <label class="text-muted"> حوزه خدمت </label>
        
                            <custom-filter *ngIf="showFilter"

                                [strValue]="returnStrValue('iMobileDomain',mdl_User.get('iMobileDomain')?.value,lst_MobileDomain,'strComment')"
                        
                                [strComment]="'strComment'"
                        
                                [stylesArray]="['padding-top: 10px','text-align: center']"
                        
                                [str_Placeholder]="'حوزه خدمت  را جستجو کنید'"
                        
                                [lst_Main]="lst_MobileDomain" 
                        
                                [lst_SearchKey]="['strComment']"
                        
                                [isDisabled]="mdl_User.disabled ? true : false"
                                
                                (hideOptions)="setValue_Filter($event,'iMobileDomain')">
                    
                            </custom-filter>
        
                        </div>

                        <!-- جایگاه کاربر -->

                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="text-muted"> جایگاه سازمانی </label>
                    
                            <custom-filter *ngIf="showFilter"
                            
                                [strValue]="returnStrValue('strChart',mdl_User.get('strChart')?.value,lst_UserManager,'strComment')"

                                [strComment]="'strComment'"
                        
                                [stylesArray]="['padding-top: 10px','text-align: center']"
                        
                                [str_Placeholder]="' جایگاه سازمانی را جستجو کنید'"
                        
                                [lst_Main]="lst_UserManager" 
                        
                                [lst_SearchKey]="['strComment']"
                        
                                [isDisabled]="mdl_User.disabled ? true : false"
                                
                                (hideOptions)="setValue_Filter($event,'strChart')">
                
                            </custom-filter>

                        </div> 

                        <!-- شماره موبایل -->

                        <ng-container *ngIf="bEditMode">
                            
                            <div class="position-relative col-12 col-md-4 p-2" style="pointer-events: none;">
                    
                                <label class="mb-2 text-muted"> شماره موبایل </label>
                    
                                <input class="form-control p-2 text-center" formControlName="strMobile" maxlength="11">
                    
                            </div>

                        </ng-container>
                        
                        <!-- کلمه عبور -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> کلمه عبور </label>
                
                            <input class="form-control p-2 text-center" formControlName="strUserPassword">
                
                        </div>

                        <!-- تکرار کلمه عبور -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> تکرار کلمه عبور </label>
                
                            <input class="form-control p-2 text-center" formControlName="strUserPassword_">
                
                        </div>
                        
                        <!-- تاریخ ثبت اشتراک -->

                        <ng-container *ngIf="bEditMode">

                            <div class="position-relative col-12 col-md-4 p-2">

                                <label class="text-muted"> تاریخ ثبت اشتراک </label>
                    
                                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                                    [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
                    
                                    <input type="text" formControlName="strSDate" disabled class="form-control text-center" />
                    
                                </ng-persian-datepicker>
                    
                            </div>

                        </ng-container>

                        <!-- تاریخ پایان اشتراک -->

                        <div class="position-relative col-12 col-md-4 p-2">

                            <label class="text-muted"> تاریخ پایان اشتراک </label>
                
                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                                [dateInitValue]="false" [dateFormat]="'jYYYY/jMM/jDD'">
                
                                <input type="text" formControlName="strEsterakEndDate" class="form-control text-center" />
                
                            </ng-persian-datepicker>
                
                        </div>

                        <!-- تعداد ورود مجاز -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> تعداد ورود مجاز </label>
                
                            <input class="form-control p-2 text-center" formControlName="iMaxInput">
                
                        </div>
                                                
                        <!-- سطح تایید سفر اداری -->

                        <div class="position-relative col-12 col-md-4 p-2">
                
                            <label class="mb-2 text-muted"> سطح تایید سفر اداری </label>
                
                            <input class="form-control p-2 text-center" oninput="this.value = this.value.replace(/[^0-9]/g,'')" formControlName="tiConfirmTripLevel">
                
                        </div>

                        <!-- ساعت شروع فعالیت -->

                        <div class="position-relative col-12 col-md-4 p-2">
        
                            <label class="mb-2 text-muted"> ساعت شروع فعالیت </label>
                    
                            <div class="input-group clockpicker">
                    
                                <input type="text" class="form-control p-2 text-center" id="Stime" formControlName="strSTime" autocomplete="off">
                    
                                <span class="input-group-addon">
                    
                                <span class="glyphicon glyphicon-time"></span>
                    
                                </span>
                    
                            </div>
                    
                        </div>

                        <!-- ساعت پایان فعالیت -->

                        <div class="position-relative col-12 col-md-4 p-2">
        
                            <label class="mb-2 text-muted"> ساعت پایان فعالیت </label>
                    
                            <div class="input-group clockpicker">
                    
                                <input type="text" class="form-control p-2 text-center" id="Etime" formControlName="strETime" autocomplete="off">
                    
                                <span class="input-group-addon">
                    
                                <span class="glyphicon glyphicon-time"></span>
                    
                                </span>
                    
                            </div>
                    
                        </div>

                        <!-- فعال -->

                        <ng-container *ngIf="bEditMode">

                            <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                                <input class="form-check-input m-0" type="checkbox" id="bEnable" formControlName="bEnable">
                            
                                <label class="form-check-label pointer text-muted me-2" for="bEnable"> فعال </label>
                            
                            </div>

                        </ng-container>

                    </div>     
                    
                </form>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn" 

                    [ngClass]="bEditMode ? 'btn-primary' : 'btn-success' "
                
                    [disabled]="mdl_User.get('strUserName')?.value == ''" 
                    
                    (click)="save_NewUser()">

                    &nbsp; {{ bEditMode ? 'ویرایش' : 'ذخیره' }} &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- دسترسی های کاربران -->

<div class="modal fade" id="access" tabindex="-1" aria-labelledby="accessLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="accessLabel">دسترسی</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="d-flex mb-2 flex-wrap dirI">

                    <div class="dirI col-md-5 col-11 mx-auto mx-md-0">

                        <input type="text" id="filterModal" class="form-control" autocomplete="one-time-code"

                            (keyup)="filterAccess($event.target)" placeholder="جستجو ">

                    </div>

                    <div class="dirI col-md-5 col-11 mt-md-0 mt-2 justify-content-around d-flex">

                        <button class="btn btn-success" (click)="addAllAccess()">اضافه کردن همه</button>

                        <button class="btn btn-danger" (click)="removeAllAccess()">حذف همه</button>

                    </div>

                </div>

                <div class="table-responsive dirI rounded" style="max-height: 60vh;">

                    <table class="table table-bordered rounded" id="">

                        <thead class="bg-secondary">

                            <tr class="text-center f14">

                                <th scope="col" class="text-white">#</th>

                                <th scope="col" class="text-white" (click)="filterAddAccess()">اختصاص</th>

                                <th scope="col" class="text-white">نوع دسترسی</th>


                            </tr>

                        </thead>

                        <tbody>

                            <tr class="text-center f12" *ngFor="let item of fullAccessSystem;let i=index">

                                <th class="text-secondary">{{i+1}}</th>

                                <th class="text-secondary">

                                    <input *ngIf="item.bHas != 0" class="form-check-input" type="checkbox" value="" checked  (click)="addOrRemoveAccess(item.strXenotakAbility)">

                                    <input *ngIf="item.bHas == 0" class="form-check-input" type="checkbox" value="" (click)="addOrRemoveAccess(item.strXenotakAbility)">

                                </th>

                                <th scope="col" class="text-secondary">{{item.strComment}}</th>

                            </tr>

                        </tbody>

                    </table>

                </div>

            </div>

        </div>

    </div>

</div>

<!-- اختصاص خودرو -->

<div class="modal fade" id="carModal" tabindex="-1" aria-labelledby="carModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="carModalLabel">اختصاص خودرو</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body ">

                <div class="d-flex mb-2 flex-wrap dirI">

                    <div class="dirI col-md-5 col-11 mx-auto mx-md-0">

                        <input type="text" id="filterModal" class="form-control" autocomplete="one-time-code" (input)="filterCar($event.target)" placeholder="جستجو ">

                    </div>

                    <div class="dirI col-md-5 col-12 mt-md-0 mt-2 justify-content-around d-flex">

                        <button class="btn btn-warning" (click)="addAllCar()">اضافه کردن همه</button>

                        <button class="btn btn-danger" (click)="removeAllCar()">حذف همه</button>

                        <button class="btn btn-primary" *ngIf="bAcssess.bSendSMS2MobilesUser" data-bs-toggle="modal" data-bs-target="#SmsModal">ارسال پیامک</button>

                        <button class="btn btn-success" (click)="exportexcel('exel-car')">خروجی اکسل</button>

                    </div>

                    <div class="dirI col-md-5 col-11 mx-auto mx-md-0">

                        <input type="text" id="filterModal" class="form-control mt-2" autocomplete="one-time-code" (keyup)="filterCarMobileDomain($event.target)" placeholder=" جستجو بر اساس حوزه خدمت ">

                    </div>

                    <span *ngIf="countBHas >= 0" class="p-3">تعداد موارد انتخاب شده: {{countBHas | faNum}} مورد</span>

                </div>


                <div class="table-responsive dirI rounded" style="max-height: 60vh;">

                    <table class="table table-bordered rounded" id="exel-car">

                        <thead class="bg-secondary">

                            <tr class="text-center f14">

                                <th scope="col" class="text-white">#</th>

                                <th scope="col" class="text-white pointer" (click)="filterAdd()">اختصاص</th>

                                <th scope="col" class="text-white">نام راننده</th>

                                <th scope="col" class="text-white">کد شناسایی خودرو</th>

                                <th scope="col" class="text-white">شماره موبایل راننده</th>

                                <th scope="col" class="text-white">حوزه خدمت</th>

                                <th scope="col" class="text-white">گروه خودرو</th>

                                <th scope="col" class="text-white">پلاک</th>

                                <th scope="col" class="text-white">تاریخ پایان اعتبار</th>

                            </tr>

                        </thead>

                        <tbody>

                            <tr class="text-center f12" *ngFor="let item of assignCarList;let i=index">

                                <th class="text-dark">{{i+1 | faNum}}</th>

                                <th class="text-dark">

                                    <input class="form-check-input" type="checkbox" id="checkedCheckBoxes" value="" checked *ngIf="item.bHas!=0" (click)="addOrRemoveCar(item.strUnitID)">

                                    <input class="form-check-input" type="checkbox" value="" *ngIf="item.bHas==0" (click)="addOrRemoveCar(item.strUnitID)">

                                    <span class="d-none" *ngIf="item.bHas!=0">true</span>

                                    <span class="d-none" *ngIf="item.bHas==0">false</span>

                                </th>

                                <th scope="col" class="text-dark">{{item.strFullName}}</th>

                                <th scope="col" class="text-dark">{{item.strUnitID | faNum}}</th>

                                <th scope="col" class="text-dark">{{item.strSystemUser_strMobile | faNum}}</th>

                                <th scope="col" class="text-dark">{{item.strMobileDomain_strComment | faNum}}</th>

                                <th scope="col" class="text-dark">{{item.strMobileGroup_strComment | faNum}}</th>

                                <th scope="col" class="text-dark">{{_other.returnCorrectPlate(item.strVehicleNo | faNum)}}</th>

                                <th scope="col" class="text-dark">{{item.strValidDate | faNum}}</th>

                            </tr>

                        </tbody>

                    </table>

                </div>

            </div>

        </div>

    </div>

</div>

<!--ارسال پیامک-->

<div class="modal fade" id="SmsModal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content">

            <div class="modal-header">

                <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="Close"></button>

                <h5 class="modal-title  ms-0" id="">ارسال پیامک</h5>

            </div>

            <div class="modal-body">

                <div class="col-12 mx-auto  dirI" [formGroup]="mdl_SMS">

                    <textarea formControlName="strSMS" placeholder="متن پبامک را وارد کنید" class="form-control mx-auto " id="smsTxt"  rows="5"></textarea>

                </div>

            </div>

            <div class="modal-footer">

                <button type="button" class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#carModal">برگشت</button>

                <button type="button" class="btn btn-primary" (click)="sendSms()">ارسال</button>

            </div>

        </div>

    </div>

</div>

<!-- حوزه خدمتی کاربر -->

<div class="modal fade" id="defineSchool" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-lg modal-dialog-centered">

        <div class="modal-content">

            <div class="modal-header">

                <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="Close"></button>

                <h5 class="modal-title  ms-0" id="">  {{!bSchool ? ' تعیین حوزه خدمت ' : 'تعیین مدارس کاربر' }}</h5>

            </div>

            <div class="modal-body" dir="rtl"> 

                <div class="row gx-2 mt-1 border border-2 ">

                    <div class="col-12 p-3">
            
                        <input type="search" #search (input)="searchBy(search.value)" class="form-control" placeholder="جستجو کنید">
            
                    </div>

                    <div class="table-responsive " style="max-height: 75vh;">

                        <table class="table table-striped">
            
                            <thead class="position-sticky top-0 bg-white">
            
                                <tr class="col-12 text-center">
            
                                    <th *ngIf="bSchool"> اختصاص </th>
            
                                    <th> {{ !bSchool ? 'حوزه خدمت' : 'نام مدرسه' }} </th>
                        
                                </tr>
            
                            </thead>
            
                            <tbody>
            
                                <tr [ngClass]="!bSchool ? 'pointer' : '' " (click)="!bSchool ? onClickMobileDomain(item,i) : '' " class="text-center col-12 " *ngFor="let item of list_schools;let i = index">
            
                                    <td> {{item.strComment | faNum}} </td>
                        
                                </tr>
            
                            </tbody>
            
                        </table>
            
                    </div>

                </div>
                
            </div>

            <div class="modal-footer">

            </div>

        </div>

    </div>

</div>

<!-- حوزه های خدمتی تحت نظارت کاربر -->

<div class="modal fade" id="supervision_service" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl modal-dialog-centered">

        <div class="modal-content">

            <div class="modal-header">

                <button type="button" class="btn-close " data-bs-dismiss="modal" aria-label="Close"></button>

                <h5 class="modal-title  ms-0" id=""> تعیین حوزه های خدمتی تحت نظارت کاربر </h5>

            </div>

            <div class="modal-body" dir="rtl"> 

                <div class="row gx-2 mt-1 border border-2 ">

                    <div class="col-12 p-3">
            
                        <input type="search" #search2 (input)="searchBy(search2.value)" class="form-control" placeholder="جستجو کنید">
            
                    </div>

                    <div class="table-responsive " style="max-height: 75vh;">

                        <table class="table table-striped">
            
                            <thead class="position-sticky top-0 bg-white">
            
                                <tr class="col-12 text-center">
            
                                    <th > اختصاص </th>
            
                                    <th> حوزه خدمت </th>
                        
                                </tr>
            
                            </thead>
            
                            <tbody>
            
                                <tr  class="text-center col-12 " *ngFor="let item of list_schools;let i = index">
            
                                    <td ><input type="checkbox" (change)="onCheckbox_($event.target.checked,item,'supervision_service')" [checked]="item.bSelected == 1 ? true : false "></td>
            
                                    <td>{{item.strComment | faNum}}</td>
                        
                                </tr>
            
                            </tbody>
            
                        </table>
            
                    </div>

                </div>
                
            </div>

            <div class="modal-footer">

            </div>

        </div>

    </div>

</div>

<!-- سابقه فعالیت کاربر -->

<div dir="rtl" class="modal fade" id="userActive" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title" id="">فعالیت کاربر</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body ">

                <input class="form-control col-10" placeholder="جستجو براساس تاریخ و نوع اقدام" (keyup)="search($event)" />

                <div class="table-responsive dirI rounded " style="max-height: 60vh;">

                    <table class="table table-striped rounded " id="excel-table-area-log">

                        <thead>

                            <tr class="text-center f14 ">

                                <th scope="col">#</th>

                                <th scope="col">نام</th>

                                <th scope="col">نوع اقدام</th>

                                <th scope="col">تاریخ</th>
                                
                                <th scope="col">زمان</th>

                                <th scope="col">توضیحات</th>

                                <th scope="col">IP</th>

                            </tr>

                        </thead>

                        <tbody>

                            <tr class="text-center pointer f12 " *ngFor="let item of userActivity;let i=index ">

                                <th class="text-secondary ">{{i+1|faNum}}</th>

                                <th class="text-secondary ">{{item.strFullName}}</th>

                                <th class="text-secondary ">{{item.strActionType_strComment}}</th>

                                <th class="text-secondary ">{{item.strDate|faNum}}</th>

                                <th class="text-secondary ">{{item.strTime|faNum}}</th>

                                <th class="text-secondary ">{{item.strAddress |faNum}}</th>

                                <th class="text-secondary"><a class="text-decoration-none text-primary pointer" target="_blank" href="https://whatismyipaddress.com/ip/{{item.strIP}}">{{item.strIP |faNum}}</a></th>

                            </tr>

                        </tbody>

                    </table>

                </div>

            </div>

            <div class="modal-footer">

                <button class="btn  btn-success" (click)="exportexcel('excel-table-area-log')">خروجی اکسل</button>

            </div>

        </div>

    </div>

</div>

<!-- گروه کاربری -->

<div class="modal fade" id="Access_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> گروه کاربری </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="section border border-2 mt-2" style="max-height:60vh;overflow: auto;">

                    <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        
                        <thead>
        
                            <tr class="">
        
                                <th class="text-center col-1"> # </th>
        
                                <th class="text-center"> عنوان </th>
        
                            </tr>
        
                        </thead>
        
                        <tbody>
        
                            <tr class="col-12 text-center pointer" *ngFor="let item of lst_Roles;let i = index" (click)="selectUserGroup(item)">
        
                                <th> {{ i + 1 | faNum }} </th>
        
                                <td> {{ item.strComment }} </td>
            
                            </tr>
        
                        </tbody>
        
                    </table>
        
                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

            </div>

        </div>

    </div>

</div>
